import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CollaborationRequestBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const requestCollaboration = createAsyncThunk<void, CollaborationRequestBody, { extra: Partial<Dependencies> }>(
  "collaborations/requestCollaboration",
  async (collaborationRequest: CollaborationRequestBody, { extra: { teacherRepository } }) => {
    return teacherRepository!.requestCollaboration(collaborationRequest);
  },
);

export const resetRequestCollaboration = createAction("collaborations/resetRequestCollaboration");
